export const MENU_ANIMATION_DURATION_MS = 200

// make sure this value aligns w/ the grid spacing in the design system
export const SIDEBAR_EXPANSION_WIDTH = 346
